<template>
    <div class="">
        <CContainer>
            <CRow class="mb-4">
                <CCol md="12" class="d-flex justify-content-end">
                    <CButton class="mr-2" color="primary" @click="() => { isEdit = !isEdit }" v-if="!isEdit">
                        <div class="button-text">
                            <CIcon name="cil-pencil" />
                            <span>Edit</span>
                        </div>
                    </CButton>
                    <template v-else>
                        <CButton class="mr-2" color="primary" @click="handleSave">
                            <div class="button-text">
                                <CIcon name="cil-check-circle" />
                                <span>Save</span>
                            </div>
                        </CButton>
                        <CButton class="mr-2" color="danger" @click="handleCancel">
                            <div class="button-text">
                                <CIcon name="cil-ban" />
                                <span>Cancel</span>
                            </div>
                        </CButton>
                    </template>
                </CCol>
            </CRow>
            <CRow>
                <CCol md="12">
                    <CCard>
                        <CCardBody>
                            <CRow>
                                <CCol sm="6">
                                    <image-uploader 
                                        class="mt-4" 
                                        ref="imageUploader"
                                        v-model="annImage"
                                        :isEdit="isEdit"
                                    />
                                </CCol>
                                <CCol sm="6">
                                    <CInput
                                        label="Title"
                                        v-model="title"
                                        placeholder="Announcement Title"
                                        :disabled="!isEdit"
                                    />
                                    <CInput
                                        label="Chinese Title"
                                        v-model="chineseTitle"
                                        placeholder="Announcement Title"
                                        :disabled="!isEdit"
                                    />
                                    <p>Content</p>
                                    <vue-editor v-model="content" :editor-toolbar="customToolbar"
                                        :disabled="!isEdit" />
                                    <br>
                                    <p>Chinese Content</p>
                                    <vue-editor v-model="chineseContent" :editor-toolbar="customToolbar"
                                        :disabled="!isEdit" />
                                    <CInput
                                        label="Button Text"
                                        class="mt-4"
                                        v-model="buttonText"
                                        placeholder="Default: Confirm"
                                        :disabled="!isEdit"
                                    />
                                    <CInput
                                        label="Chinese Button Text"
                                        class="mt-4"
                                        v-model="chineseButtonText"
                                        placeholder="-"
                                        :disabled="!isEdit"
                                    />
                                    <div class="d-flex mt-4">
                                        <CSwitch
                                            class="mr-2"
                                            size="sm"
                                            shape="pill"
                                            color="info"
                                            data-on="On"
                                            data-off="Off"
                                            :checked="show"
                                            :disabled="!isEdit"
                                            @update:checked="onSwitchChange"
                                        />
                                        <p>Show Announcement</p>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    </div>
</template>
<script>
import {
  CONFIG_GET,
  CONFIG_UPDATE,
} from '../../../constants/api'
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import ImageUploader from '../../components/ImageUploader'
export default {
    components: { VueEditor, ImageUploader },
    data() {
        return {
            isEdit: false,
            image: null,
            title: null,
            chineseTitle: null,
            content: null,
            chineseContent: null,
            show: true,
            buttonText: null,
            chineseButtonText: null,
            customToolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ 'align': [] }],
                ['clean']
            ],
            annImage: ''
        }
    },

    beforeMount() {
        this.fetchConfig()
    },
    methods: {
        async fetchConfig() {
            const config = await axios.get(`${CONFIG_GET}/announcement`, {
                headers: {
                    'x-access-token': this.accessToken
                }
            })
            const {data} = config.data
            if (data) {
                this.title = data.title
                this.chineseTitle = data.chinese_title
                this.content = data.content
                this.chineseContent = data.chinese_content
                this.show = data.show
                this.buttonText = data.buttonText
                this.chineseButtonText = data.chineseButtonText
                this.annImage = data.image
            }
        },
        handleCancel() {
            if (!window.confirm("Discard all changes?")) return
            this.isEdit = false
            this.image = null
            this.title = null
            this.content = null
            this.chineseTitle = null
            this.chineseContent = null
            this.chineseButtonText = null
            this.fetchConfig()
        },
        handleSave() {
            const image = this.annImage
            const payload = {
                newConfig: JSON.stringify({
                    content: this.content,
                    chinese_content: this.chineseContent,
                    image, 
                    title: this.title,
                    chinese_title: this.chineseTitle,
                    show: this.show,
                    buttonText: this.buttonText?.trim() || 'Confirm',
                    chineseButtonText: this.chineseButtonText
                })
            }
            axios.put(`${CONFIG_UPDATE}/announcement`, payload, {
                headers: {
                'x-access-token': this.accessToken
                }
            }).then(() => {
                this.isEdit = false
                this.fetchConfig()
            })
        },
        onSwitchChange(v) {
            this.show = v
        }
    }
}
</script>
<style scoped>
.button-text>span {
    margin-left: 6px;
}
</style>